import { Component, Input, AfterViewInit, OnDestroy, inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';

declare var L: any;

@Component({
  selector: 'app-listing-map',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="map-section">
      <h2 class="section-title">Xəritə</h2>

      <div class="map-container" [hidden]="!lat || !lng">
        <div id="detail-map" style="height: 100%; width: 100%;"></div>
      </div>

      <div class="fallback-message" *ngIf="!lat || !lng">
        Xəritə məlumatı mövcud deyil.
      </div>
    </div>
  `,
  styles: [`
    .map-section {
      padding: 32px 0;
      border-top: 1px solid #f1f2f6;
    }
    .section-title {
      font-size: 22px;
      font-weight: 700;
      margin-bottom: 16px;
      color: #2d3436;
    }
    .map-container {
      width: 100%;
      height: 400px;
      border-radius: 12px;
      overflow: hidden;
      background: #f1f2f6;
      position: relative;
    }
    .fallback-message {
      padding: 40px;
      text-align: center;
      background: #f8f9fa;
      border-radius: 12px;
      color: #636e72;
    }
  `]
})
export class ListingMapComponent implements AfterViewInit, OnDestroy {
  @Input() lat?: number;
  @Input() lng?: number;

  private map: any;
  private platformId = inject(PLATFORM_ID);

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId) && this.lat && this.lng) {
      this.initMap();
    }
  }

  private initMap() {
    setTimeout(() => {
      if (!this.lat || !this.lng) return;

      this.map = L.map('detail-map').setView([this.lat, this.lng], 17);

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(this.map);

      L.marker([this.lat, this.lng]).addTo(this.map);

      // Fix for Leaflet initialization issues
      setTimeout(() => {
        this.map.invalidateSize();
      }, 200);
    }, 100);
  }

  ngOnDestroy() {
    if (this.map) {
      this.map.remove();
    }
  }
}
